/**
 * @generated SignedSource<<339fba3d2a2aebe398d0847b65364c94>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { Fragment, ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type SharedMobileLinksBlock_viewer$data = {
  readonly isPopularSearchesEnabled: boolean | null;
  readonly isRelatedBuyPagesEnabled: boolean | null;
  readonly " $fragmentType": "SharedMobileLinksBlock_viewer";
};
export type SharedMobileLinksBlock_viewer$key = {
  readonly " $data"?: SharedMobileLinksBlock_viewer$data;
  readonly " $fragmentSpreads": FragmentRefs<"SharedMobileLinksBlock_viewer">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "SharedMobileLinksBlock_viewer",
  "selections": [
    {
      "alias": "isPopularSearchesEnabled",
      "args": [
        {
          "kind": "Literal",
          "name": "feature",
          "value": "popularSearches"
        }
      ],
      "kind": "ScalarField",
      "name": "featureFlag",
      "storageKey": "featureFlag(feature:\"popularSearches\")"
    },
    {
      "alias": "isRelatedBuyPagesEnabled",
      "args": [
        {
          "kind": "Literal",
          "name": "featureName",
          "value": "RELATED_BUY_PAGES"
        }
      ],
      "kind": "ScalarField",
      "name": "isEnabledByLocale",
      "storageKey": "isEnabledByLocale(featureName:\"RELATED_BUY_PAGES\")"
    }
  ],
  "type": "Viewer",
  "abstractKey": null
};

(node as any).hash = "fe2416ed15d742611098ef957888091d";

export default node;
